import React from 'react'
import styles from './MicrositeDateTimePicker.module.css'
import { Calendar } from 'lucide-react'

/**
 * MicrositeDateTimePicker
 * Date + time picker for scheduled publish fields (custom pages,
 * blog posts). Value/onChange use the "YYYY-MM-DDTHH:mm" format
 * native to <input type="datetime-local">, but the parent should
 * convert to "YYYY-MM-DD HH:mm:ss" before sending to the API.
 *
 * Usage:
 *   <MicrositeDateTimePicker
 *     label="Publish at"
 *     value={form.publishAt}
 *     onChange={(v) => updateField('publishAt', v)}
 *   />
 */
const MicrositeDateTimePicker = ({ label, value, onChange, helperText, disabled = false }) => (
    <div className={styles.field}>
        {label && (
            <label className={styles.label}>
                <Calendar size={12} />
                {label}
            </label>
        )}
        <input
            type="datetime-local"
            className={styles.input}
            value={value || ''}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={disabled}
        />
        {helperText && <div className={styles.helperText}>{helperText}</div>}
    </div>
)

export default MicrositeDateTimePicker